"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const contentsRef = (0, react_1.useRef)(null);
    const contents = (0, react_redux_1.useSelector)((state) => state.roomData.contents);
    const prohibitAnchorRegex = /<a\s+[^>]*href="([^"]*(open\.kakao|witchform|takemm)[^"]*)"[^>]*>/g;
    const prohibitLinkRegex = /<([^>]+)>([^<]*(open\.kakao|witchform|takemm)[^<]*)<(\/[^>]+)>/g;
    const filteredContents = contents
        .replace(prohibitAnchorRegex, '<a>')
        .replace(prohibitLinkRegex, '<p class="no_select">$2</p>');
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const { t } = (0, react_i18next_1.useTranslation)();
    if (!contents.length)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '14px',
            padding: '20px 16px',
            marginBottom: '10px',
        } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle3 gray-80" }, { children: t('상세 설명') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '4px', padding: '10px 0' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.ClipIconSvg, { css: { width: '20px', height: '20px' } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle5 gray-80" }, { children: t('하이퍼링크 미지원 안내') }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 gray-60" }, { children: t('안전한 거래를 위해 외부 하이퍼링크는 지원되지 않아요.') }))] })), (0, jsx_runtime_1.jsxs)(ContentsDiv, Object.assign({ ref: contentsRef }, { children: [(0, html_react_parser_1.default)(filteredContents), (0, jsx_runtime_1.jsx)(components_1.ShowMoreButton, { elementRef: contentsRef, dependency: contents, bottomElementId: isPreview ? '' : 'cart_order_div' })] }))] })));
}
exports.default = default_1;
const ContentsDiv = styled_1.default.div `
  word-break: break-all;
  overflow: hidden;
  > *:not(#show_more_btn) {
    max-width: 100%;
    margin-bottom: 6px;
    font-size: 16px;
    line-height: 1.5;
    * {
      line-height: 1.5;
    }
  }
  figure:not(.media) {
    display: table;
    margin: 0 auto;
  }
  img {
    max-width: 100%;
  }
  .image_resized > img {
    width: 100%;
  }
  table {
    table-layout: fixed;
    width: 100%;
    height: 100%;
    border: 1px double #b3b3b3;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: hidden;
    td {
      border: 1px solid #bfbfbf;
      min-width: 2em;
      padding: 0.4em;
    }
  }
  .image-style-block-align-left {
    margin-left: 0;
  }
  .image-style-block-align-right {
    margin-right: 0;
  }
  hr {
    height: 4px;
    border: 0;
    margin: 15px 0;
    background: #dedede;
  }
`;
